import { Box, Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';
import KeniOrb from '@/components/wrapped/KeniOrb';
import { LANDING } from '@/north-star/NorthStar.content';
import ScreenRoot from '@/components/wrapped/ScreenRoot';

// The orb-first landing: no login, no form — just Keni and two ways in. Value
// before account, per the PRD.
export type LandingScreenProps = {
  onStart: (mode: 'voice' | 'text') => void;
};

const LandingScreen = ({ onStart }: LandingScreenProps) => (
  <ScreenRoot>
    <StatusBar />

    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
      }}
    >
      <KeniOrb size={120} state='speaking' />
      <Typography sx={{ mt: 4, mb: 1.5 }} variant='h1'>
        {LANDING.greeting}
      </Typography>
      <Typography variant='body1' color='text.secondary'>
        {LANDING.blurb}
      </Typography>
    </Box>

    <Stack sx={{ px: 3 }} spacing={2}>
      <Button
        variant='primary'
        size='lg'
        isFullWidth
        ariaLabel={LANDING.speak}
        onPress={() => onStart('voice')}
      >
        {LANDING.speak}
      </Button>
      <Button
        variant='secondary'
        size='lg'
        isFullWidth
        ariaLabel={LANDING.type}
        onPress={() => onStart('text')}
      >
        {LANDING.type}
      </Button>
    </Stack>

    <HomeIndicator />
  </ScreenRoot>
);

LandingScreen.displayName = 'LandingScreen';
export default LandingScreen;
